export function matchesFaq(text, category, query, selected) {
  return (!selected || category === selected) && text.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase());
}
export function faqStructuredData(element, canonical) {
  const plain = node => (node?.textContent || '').replace(/\s+/g, ' ').trim();
  const mainEntity = [...element.querySelectorAll('[data-faq-item]')].map(item => ({
    '@type': 'Question', name: plain(item.querySelector('summary')),
    acceptedAnswer: { '@type': 'Answer', text: plain(item.querySelector('.rte')) },
  })).filter(question => question.name && question.acceptedAnswer.text);
  return mainEntity.length ? { '@context': 'https://schema.org', '@type': 'FAQPage', '@id': `${canonical}#faq`, url: canonical, mainEntity } : null;
}
class TbwlFaq extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    // Theme blocks render through content_for; section.blocks is unavailable.
    // Derive the graph from the actual crawlable disclosures, including translations.
    const canonical = document.querySelector('link[rel="canonical"]')?.href;
    const data = canonical && faqStructuredData(this, canonical);
    if (data) {
      const schema = document.createElement('script');
      schema.type = 'application/ld+json';
      schema.setAttribute('data-tbwl-faq-schema', '');
      schema.textContent = JSON.stringify(data);
      this.append(schema);
    }
    this.category = '';
    this.addEventListener('input', event => {
      if (!event.target.matches?.('[data-faq-search]')) return;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.filter(), 250);
    });
    this.addEventListener('click', event => {
      const button = event.target.closest('button[data-category]');
      if (!button) return;
      this.category = button.dataset.category;
      this.filter();
    });
  }
  filter() {
    let count = 0;
    for (const item of this.querySelectorAll('[data-faq-item]')) {
      item.hidden = !matchesFaq(item.textContent, item.dataset.category, this.querySelector('input').value, this.category);
      if (!item.hidden) count++;
    }
    for (const button of this.querySelectorAll('button[data-category]')) button.setAttribute('aria-pressed', String(button.dataset.category === this.category));
    this.querySelector('[data-faq-empty]').hidden = count > 0;
    const status = this.querySelector('[data-faq-status]');
    status.textContent = count > 0
      ? status.dataset.resultsLabel.replace('__COUNT__', String(count))
      : status.dataset.noResultsLabel;
  }
}
if (!customElements.get('tbwl-faq')) customElements.define('tbwl-faq', TbwlFaq);
